import type { DefaultDtoType, Field } from "../Field";
import { initField } from "../Field";
import type { InferOutput } from "valibot";
import { object, string } from "valibot";
import { dataName } from "../../utils/validation/base";
import isFeatureEnabled from "../../utils/featureFlag";
import FeatureFlag from "../../types/FeatureFlag";
import PropertySection from "../PropertySection";
import { TextInput } from "../../components/inputs/TextInput";
import { useTranslation } from "../../state/i18n";
import { keyFromSelector } from "i18next";

const Schema = object({
  data_name: dataName(),
});
const ValueSchema = string();

export type InstructionHTMLFieldProperties = InferOutput<typeof Schema>;
type ValueType = InferOutput<typeof ValueSchema>;

const InstructionHTMLField: Field<InstructionHTMLFieldProperties, DefaultDtoType, ValueType> = {
  type: "instructionHtml",
  category: "layout",
  widget: "com.samsonit.instructionhtml:instructionhtml:1",
  schema: Schema,
  valueSchema: ValueSchema,
  canAddToForm: () => isFeatureEnabled(FeatureFlag.FIELDS_INSTRUCTION_HTML),
  hasData: true,
  label: "no_label",
  defaultProperties: () => ({}),
  filter: {
    type: "none",
    definition: [],
  },
  stringValue: (value) => value,
  renderValue: (value) => value,
  icon: "code",
  titleKey: keyFromSelector(($) => $.INSTRUCTION_HTML_FIELD_LABEL),
  descriptionKey: keyFromSelector(($) => $.INSTRUCTION_HTML_FIELD_DESCRIPTION),
  propertyKeys: {
    data_name: keyFromSelector(($) => $.FIELD_PROPERTY_DATA_NAME),
  },
  PreviewContent: () => <div />,
  EditItem: (props) => {
    const { t } = useTranslation();

    return (
      <PropertySection>
        <TextInput
          label={t(props.propertyKeys.data_name)}
          value={props.data.properties.data_name}
          onBlur={(e) => props.setValue("data_name", e.target.value)}
          required
          errorMessage={props.getError("data_name")}
          info={{
            title: t(props.propertyKeys.data_name),
            alt: t(($) => $.FIELD_PROPERTY_DESCRIPTION_ARIA_LABEL, { property: props.propertyKeys.data_name }),
            description: t(($) => $.FIELD_PROPERTY_DATA_NAME_DESCRIPTION),
          }}
        />
      </PropertySection>
    );
  },
};

export default initField(InstructionHTMLField);
